import { iots } from '@code-expert/prelude';
import { ExamId } from '/imports/domain';
import { end, lit, type, url } from '/imports/modules/Routing';
import { UseCase } from '/imports/ui/pages/examStudent/shared';

const examId = type('examId', ExamId);
const accessToken = type('accessToken', iots.string);
const useCase = type('useCase', UseCase);

export const examLoginRoute = url(lit('loginExam'), examId, accessToken, end);
export const examLoginUseCaseRoute = url(lit('loginExam'), examId, accessToken, useCase, end);
export const examLogoutRoute = url(lit('logoutExam'), end);
export const examRoute = url(lit('examRoutes'), examId, accessToken, end);
export const examReviewRoute = url(lit('examReview'), examId, accessToken, end);
export const examStudentRoute = url(lit('examStudent'), examId, end);
